export default __webpack_public_path__ + "static/media/SpringBook_08.40acb8c7.png";